import { render, staticRenderFns } from "./ExerciseLogic.vue?vue&type=template&id=6c93453a&"
import script from "./ExerciseLogic.vue?vue&type=script&lang=js&"
export * from "./ExerciseLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports